<template>
    <div class="merchant-list">
        <div class="row">
            <merchant-item
                v-for="item in merchantList"
                :key="item.merchantPubId"
                :checked="value === item.merchantPubId"
                :show-radio="showRadio"
                :merchant-en-name="item.merchantEnName"
                :disabled="item.disabled"
                @change="handleChange"
            />
        </div>
    </div>
</template>

<script>
import MerchantItem from './components/merchant-item';

export default {
    name: 'SyMerchantList',
    components: {
        MerchantItem
    },
    props: {
        // 所有商户
        merchantList: {
            type: Array,
            default: () => [
                // 行必达名称
                'XINGBIDA',
                // 道依茨
                'DEUTZ'
            ]
        },
        // 是否显示单选框
        showRadio: {
            type: Boolean,
            default: true
        },
        // 当前商户
        value: {
            type: String,
            default: ''
        }
    },
    methods: {
        /**
         * 处理点击事件
         */
        handleChange(event) {
            let found = _.find(this.merchantList, item => {
                return item.merchantEnName === event;
            });
            if (found) {
                this.$emit('input', found.merchantPubId);
                return;
            }
            this.$emit('input1', null);
        }
    }
};
</script>

<style lang="scss" scoped>
.merchant-list {
    .row {
        display: flex;
        flex-wrap: wrap;
    }

    .merchant-item {
        margin: 0 23px 23px 0;
    }
}

@media only screen and (max-width: 800px) {
    .merchant-list {
        min-width: 200px;
    }
}
</style>
